<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
                ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="num" label="ID" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[3476]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_name" :label="$t('getapi[585]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="r_code" :label="$t('getapi[6328]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="r_name" :label="$t('getapi[6329]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="r_priority" :label="$t('getapi[6032]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="work_calendar_code" :label="$t('getapi[6330]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="free_threshold" :label="$t('getapi[6331]')"></el-table-column>
            <el-table-column prop="mansign_flg_name" :label="$t('getapi[6408]')">
                <template scope="scope">
                    <span>{{ scope.row.mansign_flg_name | lanchange}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="r_days" :label="$t('getapi[6333]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="CDeviceNM" :label="$t('getapi[12213]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="group_name" :label="$t('getapi[12444]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="board_flag_name" :label="$t('getapi[12799]')"></el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text"
                               size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]')
                            }}
                        </el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 表格 -->
        <!-- 分页 -->
        <el-row class="page">
            <el-col :span="12">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[50, 100, 200, 300, 400]"
                        :page-size="PageSize"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="12">
                <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- 分页 -->
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="50%"
                   :close-on-click-modal="false">
            <!--<el-row>
                <el-col :span="24">
                    <el-form :inline="true" :model="dataList" class="demo-form-inline" label-width="100px"
                             label-position="left" size="small">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[3476]')">
                                    <el-input
                                            v-model="dataList.workcenter_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectWorkCenter()"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[585]')">
                                    <el-input v-model="dataList.workcenter_name" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6328]')">
                                    <el-input v-model="dataList.r_code"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6329]')">
                                    <el-input v-model="dataList.r_name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6032]')">
                                    <el-input v-model="dataList.r_priority"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6330]')">
                                    <el-input
                                            v-model="dataList.work_calendar_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectWorkCalendar()"></i>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6331]')">
                                    <el-input v-model="dataList.free_threshold"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6332]')">
                                    <el-checkbox v-model="dataList.mansign_flg" :true-label=1 :false-label=0></el-checkbox>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item :label="$t('getapi[6333]')">
                                    <el-input v-model="dataList.r_days"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-col>
            </el-row>-->
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[3476]')}}</td>
                        <td>
                            <routejump :urlNo="15" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="dataList.workcenter_code"
                                    type="text"
                                    readonly
                                    class="mcolor"
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectWorkCenter()"></i>
                            </el-input>
                            </routejump>
                        </td>
                        <td>{{$t('getapi[585]')}}</td>
                        <td><el-input v-model="dataList.workcenter_name" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6328]')}}</td>
                        <td><el-input v-model="dataList.r_code"></el-input></td>
                        <td>{{$t('getapi[6329]')}}</td>
                        <td><el-input v-model="dataList.r_name"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6032]')}}</td>
                        <td><el-input v-model="dataList.r_priority"></el-input></td>
                        <td>{{$t('getapi[6330]')}}</td>
                        <td>
                            <routejump :urlNo="44" :isDialog="1" @callback="beforeRoutJump">
                            <el-input
                                    v-model="dataList.work_calendar_code"
                                    type="text"
                                    readonly
                                    class="mcolor"
                                    size="mini"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectWorkCalendar()"></i>
                            </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6331]')}}</td>
                        <td><el-input v-model="dataList.free_threshold"></el-input></td>
                        <td>{{$t('getapi[6332]')}}</td>
                        <td><el-checkbox v-model="dataList.mansign_flg" :true-label=1 :false-label=0></el-checkbox></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[6333]')}}</td>
                        <td><el-input v-model="dataList.r_days"></el-input></td>
                        <td>{{$t('getapi[12444]')}}</td>
                        <td>
                            <routejump :urlNo="45" :isDialog="1" @callback="beforeRoutJump">
                                <el-input
                                        v-model="dataList.group_name"
                                        type="text"
                                        readonly
                                        class="mcolor"
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectGroupName()"></i>
                                </el-input>
                            </routejump>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12213]')}}</td>
                        <td colspan="3">
                            <el-select filterable multiple v-model="devicearr" size="mini" style="width: 100%">
                                <el-option v-for="item in DeviceInfo" :key="item.DeviceID" :label="item.Name"
                                           :value="item.DeviceID"></el-option>
                            </el-select>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12799]')}}</td>
                        <td>
                            <el-checkbox v-model="dataList.board_flag" :true-label=1 :false-label=0></el-checkbox>
                        </td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isVisible = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading"
                           :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetWorkCenterPopupList'" @callback="getWorkCenter" ref="workcenter"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetWorkCalendarPopupList'" @callback="getWorkCalendar" ref="workcalendar"></selector>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pro/SchPro/GetGroupNamePopupList'" @callback="getGroupName" ref="groupname"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
        name: '2_resource',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                oldDataList:[],
                PageIndex: 1,
                PageSize: this.$http.getPageSize('2_resource'),
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectData: [],
                ids: "",
                btn: {
                    del: false,
                    edit: false
                },
                devicearr: [],
                DeviceInfo: [],
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6327]"),this.$t("getapi[20]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if(that.selectData.length>0){
                    that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del')
                } else {
                    that.$refs.SetBtn.SetButtonEnable('create,save,refresh')
                }
                that.btnauthority()
            },
            btnauthority(){
                let that = this
                that.btn.edit = true;
                that.btn.del = true;
            },
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.$http.savePageSize('2_resource',val)
                this.intidata();
                this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
                this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isVisible = true
                that.getDevice()
                that.dataList = {
                    num: row.num,
                    workcenter_code: row.workcenter_code,
                    r_code: row.r_code,
                    r_name: row.r_name,
                    r_priority: row.r_priority,
                    free_time: '',
                    work_calendar_code: row.work_calendar_code,
                    free_threshold: row.free_threshold,
                    mansign_flg: row.mansign_flg,
                    r_days: row.r_days,
                    device_id: row.device_ids,
                    group_name: row.group_name,
                    board_flag: row.board_flag,
                }
                that.oldDataList = JSON.stringify(that.dataList)
                that.devicearr = []
                that.devicearr = that.dataList.device_id.split(',')
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: ''
                };
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Param: []
                };
                that.queryData.forEach(item => {
//                    if(item.query_Condition==''||item.query_Condition.length>0) {
                    pm = {
                        query_Condition: item.query_Condition,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
//                    }
                });
                that.$http.urlpost('/Pro/SchPro/GetAllAPSResourceView', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                that.loading = true;
                let str = ''
                for(let i=0;i<that.devicearr.length;i++){
                    str = str + that.devicearr[i] + ','
                }
                that.dataList.device_id = str.substring(0,str.length-1)
                let parm = that.dataList
                that.$http.urlpost('/Pro/SchPro/SaveApsResource', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i])
                }
                that.authority()
            },
            // 删除
            delf() {
                let that = this;
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        num: that.selectData[i].num
                    }]
                }
                let parm = {
                    list: arr
                };
                that.$http.urlpost('/Pro/SchPro/DelApsResource', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            // 删除
            del(row) {
                let that = this
                let parm = {
                    list: [{
                        num: row.row.num
                    }]
                }
                that.$http.urlpost('/Pro/SchPro/DelApsResource', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                });
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    num: 0,
                    workcenter_code: '',
                    r_code: '',
                    r_name: '',
                    r_priority: 0,
                    free_time: '',
                    work_calendar_code: '',
                    free_threshold: 0,
                    mansign_flg: 0,
                    r_days: 0,
                    group_name: ''
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            selectWorkCenter(){
                let that = this;
                that.$refs.workcenter.clearInput(true);
            },
            getWorkCenter(val){
                let that = this;
                console.log(val)
                that.dataList.workcenter_code = val.workcenter_code;
                that.dataList.workcenter_name = val.workcenter_name
            },
            selectWorkCalendar(){
                let that = this;
                that.$refs.workcalendar.clearInput(true);
            },
            getWorkCalendar(val){
                let that = this;
                console.log(val)
                that.dataList.work_calendar_code = val.cd_code;
            },
            getDevice(val) {
                let that = this;
                let parm = {
                }
                that.$http.urlpost('/Pro/SchPro/GetDeviceList', parm, function (res) {
                    if (res.Success == 1) {
                        that.DeviceInfo = res.DataContent.Table
                        for(let i=0;i<that.DeviceInfo.length;i++){
                            that.DeviceInfo[i].Name = that.DeviceInfo[i].DeviceName + '(' +that.DeviceInfo[i].DeviceID +')'
                        }
                    }
                });
            },
            selectGroupName(){
                let that = this;
                that.$refs.groupname.clearInput(true);
            },
            getGroupName(val){
                let that = this;
                console.log(val)
                that.dataList.group_name = val.group_name
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataList != JSON.stringify(that.dataList)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
